import axios from "axios";

var TransactionAccessMockService = function () {
    var service = this;

    function txnAccessSuccess(results) {
        return results.data;
    }

    function executeGet(url, faultLabel, params) {
        return axios
            .get(url, { ...params, withCredentials: true })
            .then(
                (response) => {
                    return response;
                },
                function (error) {
                    console.log(faultLabel + " error found", error);
                }
            )
            .catch((err) => {
                console.log(faultLabel + " error found", err);
                throw err;
            });
    }

    service.getTxnAccessMocks = function (queryParam, mockFileName) {
        const url = window.location.origin + window.location.pathname + mockFileName;

        return executeGet(url, "txnAccessFault", queryParam)
            .then(txnAccessSuccess)
            .catch((e) => {
                LogService.getLogger().error("Error retrieving mock fiie, " + mockFileName);
            });
    };
};

export default TransactionAccessMockService;
